import { render, staticRenderFns } from "./index.vue?vue&type=template&id=755fac6d&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jonas/Projects/Risolto/operator-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('755fac6d')) {
      api.createRecord('755fac6d', component.options)
    } else {
      api.reload('755fac6d', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=755fac6d&", function () {
      api.rerender('755fac6d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quicksight/index.vue"
export default component.exports